<input type="file" #fileInput (change)="onFileSelected($event)" style="display: none;" accept="image/*">
<button (click)="fileInput.click()" type="button" class="custom-button">Subir foto</button>
